<template>
  <report-form
    v-model="payload"
    :page-title="$t('app.reports.recebiveis.title')"
    :request-class="requestClass"
    :total-group="1"
    navigate-back-route="Reports"
    navigate-page-after-save="Reports"
  >
    <template slot="group-1">
      <form-group :title="$t('app.reports.subtitle')">
        <v-flex
          xs12
          lg6
        >
          <input-text
            v-model="payload.client"
            return-masked-value
            max-length="100"
            :label="$t('app.reports.recebiveis.form.client')"
          />
          <input-text
            v-model="payload.cpfCnpj"
            :mask="cpfOrCnpjMask"
            return-masked-value
            required
            :label="$t('app.reports.recebiveis.form.document')"
          />
          <date-interval
            id="dateInterval"
            v-model="payload.period"
            identifier="period"
            required
          />
          <span>{{ $t('app.reports.recebiveis.form.type.title') }}</span>
          <v-layout>
            <v-flex
              xs12
              md6
            >
              <v-checkbox
                v-model="payload.type"
                :label="$t('app.reports.recebiveis.form.type.emprestimo')"
                value="emprestimo"
                color="#8B0005"
                :rules="[isEmpty]"
              />
            </v-flex>
            <v-flex
              xs12
              md6
            >
              <v-checkbox
                v-model="payload.type"
                :label="$t('app.reports.recebiveis.form.type.prorrogacao')"
                value="prorrogacao"
                color="#8B0005"
                :rules="[isEmpty]"
              />
            </v-flex>
          </v-layout>
          <span>{{ $t('app.reports.recebiveis.form.status.title') }}</span>
          <v-layout>
            <v-flex
              xs12
              md6
            >
              <v-checkbox
                v-model="payload.status"
                :label="$t('app.reports.recebiveis.form.status.regular')"
                value="regularizada"
                color="#8B0005"
                :rules="[isEmpty]"
              />
            </v-flex>
            <v-flex
              xs12
              md6
            >
              <v-checkbox
                v-model="payload.status"
                :label="$t('app.reports.recebiveis.form.status.irregular')"
                value="irregular"
                color="#8B0005"
                :rules="[isEmpty]"
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </form-group>
    </template>
  </report-form>
</template>

<script>
import DateInterval from 'Support/components/reports/DateInterval.vue';
import FormGroup from 'Support/layout/FormGroup.vue';
import RecebiveisRequest from 'Domain/reports/RecebiveisRequest';
import ReportForm from 'Support/components/reports/ReportForm.vue';
import RulesMixin from 'Support/mixins/rules-mixin';
import ReportMixin from 'Support/mixins/ReportMixin';
import InputText from 'Support/components/inputs/InputText.vue';

export default {
  name: 'RecebiveisReport',
  components: {
    ReportForm,
    FormGroup,
    DateInterval,
    InputText,
  },
  mixins: [RulesMixin, ReportMixin],
  data: () => ({
    requestClass: RecebiveisRequest,
    payload: {
      client: '',
      cpfCnpj: '',
      period: {
        dataInicial: '',
        dataFinal: '',
      },
    },
  }),
  computed: {
    cpfOrCnpjMask() {
      return this.payload.cpfCnpj.length < 12 ? '###.###.###-###' : '##.###.###/####-##';
    },
  },
};
</script>
